import React from 'react'
import PropTypes from 'prop-types'

import firebase from 'firebase'
// import AlertContainer from 'react-alert'
// import { alertOptions } from '../../../../resources/utilities'

import { dataAppDatabase, locale, polyglot } from '../../../../index'
import { TEETH } from '../../TeethView/TeethPositionConstants'
import Loading from '../../../common/Loading/Loading'
import { ReactModal } from '../../../common/ReactModal/ReactModal'
import ToothStateForm from '../../TeethView/ToothStateForm/ToothStateForm'
import TeethViewer, { STATE } from '../../TeethView/TeethViewer'

export default class TeethsView extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      modalIsOpen: false,
      clickedId: undefined,
      clickedState: undefined,
      config: undefined
    }
    this.toggleModal = this.toggleModal.bind(this)
    this.submitToothStatusChange = this.submitToothStatusChange.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.submitChanges = this.submitChanges.bind(this)
    this.pushChangesToDatabase = this.pushChangesToDatabase.bind(this)
    this.updateTeeth = this.updateTeeth.bind(this)
    this.getConfiguration = this.getConfiguration.bind(this)
  }

  updateTeeth (props) {
    dentes = TEETH.convertToArray(props.currentAgeTeeth).map((value) => ({
      id: value.id,
      state: STATE.NORMAL,
      position: value})
    )
    if (props.teethStatus) {
      let patientTeethStatus = props.teethStatus
      let _newTeeth = dentes.map(value => {
        Object.keys(patientTeethStatus).forEach(val => {
          if (patientTeethStatus[val].id === value.id) {
            value.state = patientTeethStatus[val].state
          }
          return value
        })
        return value
      })
      this.setState({
        teeth: _newTeeth,
        patientTeeth: patientTeethStatus
      })
    } else {
      this.setState({
        teeth: dentes
      })
    }
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('riso').child('configuration')
    config.on('value', dataSnapshot => {
      this.setState({
        config: dataSnapshot.child('toothStatusChange').val()
      })
    })
  }

  componentWillMount () {
    this.updateTeeth(this.props)
    this.getConfiguration()
  }

  toggleModal ({id, currentState}) {
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
      clickedId: id,
      clickedState: currentState
    })
    return new Promise((resolve) => {
      resolve({id, nextState: currentState})
    })
  }

  componentWillReceiveProps (props) {
    this.updateTeeth(props)
  }

  closeModal () {
    this.setState({
      modalIsOpen: false
    })
  }

  submitToothStatusChange (tooth, state) {
    this.closeModal()
    let newTeeth = dentes.map((value) => {
      if (value.id === tooth) {
        value.state = state
      }
      return value
    })
    let updated = this.state.patientTeeth
    if (updated) {
      if (state !== 'normal') {
        if (Object.keys(updated).indexOf(tooth) === -1) {
          updated[tooth] = {id: tooth, state: state}
        } else {
          Object.keys(updated).forEach(key => {
            if (updated[key].id === tooth) {
              updated[key].state = state
            }
          })
        }
      } else {
        Object.keys(updated).forEach(key => {
          if (updated[key].id === tooth) {
            updated[key] = null
          }
        })
      }
    } else {
      updated[tooth] = {id: tooth, state: state}
    }
    this.setState({
      teeth: newTeeth,
      patientTeeth: updated
    }, () => {
      this.pushChangesToDatabase(updated)
    })
  }

  submitChanges (tooth, state) {
    let updated = this.state.patientTeeth
    if (updated) {
      updated.push({id: tooth, state: state})
    } else {
      updated = []
      updated.push({id: tooth, state: state})
    }
  }

  pushChangesToDatabase () {
    this.setState({
      loading: 'cursor-loading'
    })
    const rootRef = dataAppDatabase.ref()
    const teethStatusDataRef = rootRef.child('riso').child('patientsByCountry').child(locale).child(this.props.patientKey).child('data').child('teethStatus')
    teethStatusDataRef.set(this.state.patientTeeth).then(() => {
      this.setState({
        loading: ''
      })
      // this.msg.success(polyglot.t('toothStatusChange.toothStatusSuccessfullyChanged'))
    })
  }

  render () {
    return (
      <div>
        <div className='row'>
          {/* <AlertContainer ref={a => { this.msg = a }} {...alertOptions} /> */}
          <div className='col-xs-12 no-side-padding'>
            <div className='thumbnail' style={{textAlign: 'center', fontSize: '35px', minHeight: '300px'}}>
              {!this.state.teeth ? <Loading />
                : <TeethViewer key={this.props.age} teeth={this.state.teeth} onclick={this.toggleModal} />
              }
            </div>
          </div>
          {this.state.config
            ? <ReactModal name={polyglot.t(this.state.config.title)} toggleModal={this.toggleModal} modalIsOpen={this.state.modalIsOpen} >
              <ToothStateForm config={this.state.config} id={this.state.clickedId} state={this.state.clickedState} submitChange={this.submitToothStatusChange} />
            </ReactModal>
            : null
          }
        </div>
      </div>
    )
  }
}

TeethsView.propTypes = {
  patientKey: PropTypes.string.isRequired,
  currentAge: PropTypes.string.isRequired,
  teethStatus: PropTypes.object.isRequired
}

let dentes



// WEBPACK FOOTER //
// ./src/components/general/Home/TeethView/TeethView.js